var exports = {
  "uL": "NativeTitlebar.module__titlebar___RWJvMG",
  "b6": "NativeTitlebar.module__history___RWJvMG",
  "jg": "NativeTitlebar.module__historyButton___RWJvMG",
  "gX": "NativeTitlebar.module__center___RWJvMG",
  "_O": "NativeTitlebar.module__context___RWJvMG",
  "g8": "NativeTitlebar.module__contextLabel___RWJvMG",
  "fd": "NativeTitlebar.module__contextIcon___RWJvMG",
  "Bg": "NativeTitlebar.module__contextMark___RWJvMG",
  "o_": "NativeTitlebar.module__contextGuildIcon___RWJvMG",
  "f$": "NativeTitlebar.module__contextAvatar___RWJvMG",
  "jH": "NativeTitlebar.module__spacer___RWJvMG",
  "ne": "NativeTitlebar.module__controls___RWJvMG",
  "uH": "NativeTitlebar.module__controlButton___RWJvMG",
  "b": "NativeTitlebar.module__closeButton___RWJvMG",
};

module.exports = exports;
